export const IMEI = 'IMEI'
export const LOGGIN_IN = `${IMEI}:user:loggin_in`
export const DO_LOGIN = `${IMEI}:user:do_login`
export const STORE_USER = `${IMEI}:user:store`
export const PROFILE = `${IMEI}:user:profile`
export const PROFILE_UPDATE = `${IMEI}:user:profile:update`
export const BALANCE_UPDATE = `${IMEI}:user:balance:update`
export const LOGOUT = `${IMEI}:user:logout`
export const LOGGED_OUT = `${IMEI}:user:loggedout`
export const USER_ID = `${IMEI}:user:id`
export const TOKEN = `${IMEI}:auth:token`
